import { composeModule } from '../composeActions';
import pkg from '../package.json';

var _composeModule = composeModule("".concat(pkg.name, "/core"), pkg.version),
    composeStateMachine = _composeModule.composeStateMachine,
    composeEffects = _composeModule.composeEffects,
    composeMiddleware = _composeModule.composeMiddleware,
    composeSubscriber = _composeModule.composeSubscriber,
    exportModule = _composeModule.exportModule,
    namespace = _composeModule.namespace;

export { composeStateMachine, composeEffects, composeMiddleware, composeSubscriber, exportModule, namespace };